export const getSnapshotDueDismissKey = (userId: string | number) =>
  `snapshot:${userId}:due-dismissed`;

export const dismissSnapshotDueForSession = (userId: string | number) => {
  sessionStorage.setItem(getSnapshotDueDismissKey(userId), '1');
};

export const clearSnapshotDueDismissal = (userId: string | number) => {
  sessionStorage.removeItem(getSnapshotDueDismissKey(userId));
};

export const isSnapshotDueDismissed = (userId: string | number) =>
  sessionStorage.getItem(getSnapshotDueDismissKey(userId)) === '1';
